export default __webpack_public_path__ + "static/media/user.0616e3ee.svg";